import { render, staticRenderFns } from "./providedOffer.vue?vue&type=template&id=2264879f&scoped=true"
import script from "./providedOffer.vue?vue&type=script&lang=js"
export * from "./providedOffer.vue?vue&type=script&lang=js"
import style0 from "./providedOffer.vue?vue&type=style&index=0&id=2264879f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2264879f",
  null
  
)

export default component.exports